import Vue from 'vue'
//import Store from './vuex/store'
import Router from 'vue-router'
//import Utilities from './utilities'
import Homepage from '@/components/views/homepage/homepage'
import RegaliAziendali from '@/components/views/regali-aziendali/regali-aziendali'
import InstantWin from '@/components/views/instant-win/instant-win'
import LoyaltyPlan from '@/components/views/loyalty-plan/loyalty-plan'
import ConcorsoPremi from '@/components/views/concorso-premi/concorso-premi'
import OperazioniPremioCerto from '@/components/views/operazioni-premio-certo/operazioni-premio-certo'
import Incentive from '@/components/views/incentive/incentive'
import Welfare from '@/components/views/welfare/welfare'
import TravelBrand from '@/components/views/travel-brand/travel-brand'
  
Vue.use(Router)

let router = new Router({
    mode: process.env.VUE_APP_ROUTER_MODE,
    /*
    scrollBehavior: function(to) {
      if(process.env.VUE_APP_ROUTER_MODE == 'history' && to.path.indexOf('#') > 0){
        return {selector: to.path.substr(to.path.indexOf('#'))}
      }else{
        return {selector: '#app'}
      }
    },*/    
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
          return savedPosition
        } else {
          return { x: 0, y: 0 }
        }
    },   
    routes: [
        {
            path: '/',
            name: 'homepage',
            component: Homepage,
        },
        {
            path: '/regali-aziendali',
            name: 'regali-aziendali',
            component: RegaliAziendali,
        },        
        {
            path: '/instant-win',
            name: 'instant-win',
            component: InstantWin,
        },        
        {
            path: '/loyalty-plan',
            name: 'loyalty-plan',
            component: LoyaltyPlan,
        },        
        {
            path: '/concorso-a-premi',
            name: 'concorso-premi',
            component: ConcorsoPremi,
        },        
        {
            path: '/operazioni-a-premio-certo',
            name: 'operazioni-premio-certo',
            component: OperazioniPremioCerto,
        },        
        {
            path: '/incentive',
            name: 'incentive',
            component: Incentive,
        },        
        {
            path: '/welfare',
            name: 'welfare',
            component: Welfare,
        },        
        {
            path: '/travel-brand',
            name: 'travel-brand',
            component: TravelBrand,
        },        
        /* esempio con props passate da url
        {
            path: '/in-salabam/:inSalabamId/:inSalabamTitle',
            name: 'in-salabam',
            component: HomeInSalabam,
            publicRoute: true, //custom attribute
            props: true
        },
        */
        // gestisce i "404", !!! DEVE STARE PER ULTIMA !!!
        {
            path: '*',
            name: 'notFound',
            redirect: '/',
            //publicRoute: true, //custom attribute
        },
    ]
})


router.beforeEach((to, from, next) => {    
    // se devo andare in manutenzione non controllare nient'altro: vai in manutenzinoe
    if (to.name == 'maintenance')
    {
        next()
        return
    }
    /*
    let route = router.options.routes.filter(function (r) {
        if(to.matched.length > 0)
        {
            return r.name == to.matched[0].name
        }
    })[0]
    */

    // altrimenti naviga as usual
    next()
})


router.afterEach((to) => {
    // per scrollare alle sezioni di id #id
    // bisogna gestirlo in parte manualmente
    // se hai già il sito caricato, i fragment funzionano
    // ma se arrivi da fuori con link con fragment, va gestito così
    if(to.hash && to.hash != ''){
        //if(process.env.VUE_APP_MODE != 'production') window.console.log('fragment found')
        // TODO fare interval 500, check element id != undefined, trigger
        setTimeout(function(){
            //if(process.env.VUE_APP_MODE != 'production') window.console.log('scrolling to ' + to.hash)
            document.getElementById(to.hash.substr(1)).scrollIntoView();
        }, 500); // setTimeout
    }
})


export default router